import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungAugsburg() {
  return (
    <CityPageTemplate
      city="Augsburg"
      slug="augsburg"
      intro="Augsburg als eine der ältesten Städte Deutschlands – Deine Finanzen sollten aber modern und zukunftssicher sein."
      description="Unabhängige & digitale Finanzberatung für Augsburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
